import _ from 'lodash';
import { TicketStatesTransferring, TicketStatesReceiving } from '../../../../components/ticket/ticket.constants';

export const TicketLists = [
  { label: 'active', filter: { closed: false } },
  { label: 'closed', filter: { closed: true } }
];

export const RelevantTicketStatesForTransferring = _.values(TicketStatesTransferring);

export const RelevantTicketStatesForReceiving = _.values(TicketStatesReceiving);

export const SearchSuggestions = {
  bankGroup: [{
    value: 0,
    valueAddition: 'Deutsche-Bundesbank'
  },{
    value: 1,
    valueAddition: 'Kreditinstitute, soweit nicht in einer anderen Gruppe erfasst, und Deutsche Postbank AG'
  },{
    value: 2,
    valueAddition: 'Kreditinstitute, soweit nicht in einer anderen Gruppe erfasst (früher: Regional-, Lokal-, Spezial-, Haus- und Branchenbanken – z. B. HypoVereinsbank)'
  },{
    value: 3,
    valueAddition: 'Kreditinstitute, soweit nicht in einer anderen Gruppe erfasst (früher: Privatbankiers) – z. B. BNP Paribas (Consorsbank)'
  },{
    value: 4,
    valueAddition: 'Commerzbank und Tochterinstitute (z. B. comdirect bank)'
  },{
    value: 5,
    valueAddition: 'Sparkassen und Landesbanken'
  },{
    value: 6,
    valueAddition: 'Genossenschaftliche Zentralbanken und Raiffeisenbanken (bzw. Kreditgenossenschaften)'
  },{
    value: 7,
    valueAddition: 'Deutsche Bank und Tochterinstitute'
  },{
    value: 8,
    valueAddition: 'Commerzbank (ehem. Dresdner Bank)'
  },{
    value: 9,
    valueAddition: 'Volksbanken (bzw. Kreditgenossenschaften)'
  }],
  openStandingOrders: [
    { value: true, valueAddition: 'Dauerauftragsanlage offen', valueHidden: true }
  ]
};
